import { Link, NavLink } from "react-router-dom";
import "./sidebar.scss";
import { permissions } from "../../../roles";
import { AiOutlinePieChart } from "react-icons/ai";
import { TiDocumentAdd } from "react-icons/ti";
import { MdOutlinePeopleAlt } from "react-icons/md";
import { FiLock } from "react-icons/fi";
import { RxDashboard } from "react-icons/rx";
import { FaRegCircleUser } from "react-icons/fa6";
import { TiHomeOutline } from "react-icons/ti";
import { LuLayoutDashboard } from "react-icons/lu";
import { MdHelpOutline } from "react-icons/md";
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';
const Sidebar = () => {
  const role = atob(sessionStorage.getItem("key") || "");
  const handleLogout = () => {
    sessionStorage.clear();
    window.location.assign(`${process.env.REACT_APP_COGNITOSSO_LOGOUT_URL}`);
  };
  return (
    <nav>
      <ul>
        <li>
          <Link to="">
            <div>
              {/* <img
                className="sidebar_img"
                src={require("../../../images/avatar.png")}
                alt=""
              /> */}
              {/* <FaRegCircleUser  className="sidebar_img" style={{fontSize:'20px'}}/> */}
              <TiHomeOutline className="sidebar_img" style={{fontSize:'30px'}}/>
              {/* <span>{`${sessionStorage.getItem(
                "PBT_FIRSTNAME"
              )} ${sessionStorage.getItem("PBT_LASTNAME")}`}</span> */}
              <span>Home</span>
            </div>
          </Link>
        </li>
 
        {permissions[role?.toUpperCase()]?.includes("dashboard") && (
          <li>
            <NavLink
              to="/dashboard"
              style={({ isActive }) => {
                return isActive
                  ? { backgroundColor: "#064ee829" }
                  : { backgroundColor: "" };
              }}
            >
              <div>
                {/* <img
                  className="sidebar_img"
                  src={require("../../../images/dashboard.png")}
                  alt=""
                /> */}
                <LuLayoutDashboard className="sidebar_img" style={{fontSize:'22px'}}/>
                <span>Dashboard</span>
              </div>
            </NavLink>
          </li>
        )}
        {permissions[role?.toUpperCase()]?.includes("dashboard") && (
          <li>
            <NavLink
              to="/dashboard/create-project"
              style={({ isActive }) => {
                return isActive
                  ? { backgroundColor: "#064ee829" }
                  : { backgroundColor: "" };
              }}
            >
              <div>
                <TiDocumentAdd className="sidebar_img" style={{fontSize:'30px'}}/>
                <span>Log New</span>
                <span>Assessment/</span>
                <span>Readiness</span>
                <span>Assessment</span>
              </div>
            </NavLink>
          </li>
        )}
        {permissions[role?.toUpperCase()]?.includes("question") && (
          <li>
            <NavLink
              to="/create-your-question"
              style={({ isActive }) => {
                return isActive
                  ? { backgroundColor: "#064ee829" }
                  : { backgroundColor: "" };
              }}
            >
              <div>
                <TiDocumentAdd className="sidebar_img" style={{fontSize:'30px'}}/>
                <span>Add/Modify</span>
                <span>Questionnaire</span>
              </div>
            </NavLink>
          </li>
        )}
        {permissions[role?.toUpperCase()]?.includes("case-study") && (
          <li>
            <NavLink
              to="/case-study"
              style={({ isActive }) => {
                return isActive
                  ? { backgroundColor: "#064ee829" }
                  : { backgroundColor: "" };
              }}
            >
              <div>
                <FindInPageOutlinedIcon className="sidebar_img" style={{fontSize:'30px'}}/>
                <span>Case</span> <span>Study</span>
              </div>
            </NavLink>
          </li>
        )}
        {permissions[role?.toUpperCase()]?.includes("leadership") && (
          <li>
            <NavLink
              to="/leadership-report"
              style={({ isActive }) => {
                return isActive
                  ? { backgroundColor: "#064ee829" }
                  : { backgroundColor: "" };
              }}
            >
              <div>
                <AiOutlinePieChart className="sidebar_img" style={{fontSize:'30px'}} />
                {/* <img
                  className="sidebar_img"
                  src={require("../../../images/leadership.png")}
                  alt=""
                /> */}
                <span>Leadership</span><span>Report</span>
              </div>
            </NavLink>
          </li>
        )}
        {permissions[role?.toUpperCase()]?.includes("access") && (
          <li>
            <NavLink
              to="/access-management"
              style={({ isActive }) => {
                return isActive
                  ? { backgroundColor: "#064ee829" }
                  : { backgroundColor: "" };
              }}
            >
              <div>
                {/* <img
                  className="sidebar_img"
                  src={require("../../../images/access.png")}
                  alt=""
                /> */}
                <MdOutlinePeopleAlt className="sidebar_img" style={{fontSize:'30px'}}/>
                <span>Access </span><span>Management</span>
              </div>
            </NavLink>
          </li>
        )}
        {permissions[role?.toUpperCase()]?.includes("faq") && (
          <li>
            <NavLink
              to="/faq"
              style={({ isActive }) => {
                return isActive
                  ? { backgroundColor: "#FF6E61" }
                  : { backgroundColor: "" };
              }}
            >
              <div>
                <MdHelpOutline className="sidebar_img" style={{fontSize:'30px'}}/>
                <span>FAQs</span>
              </div>
            </NavLink>
          </li>
        )}
        <li className="logout" onClick={handleLogout}>
          <a style={{ cursor: "pointer" }}>
            <div>
              {/* <img
                className="sidebar_img"
                src={require("../../../images/logout.png")}
               
                alt=""
              /> */}
              <FiLock  className="sidebar_img" style={{fontSize:'20px'}}/>
              <span>Logout</span>
            </div>
          </a>
        </li>
      </ul>
    </nav>
  );
};
 
export default Sidebar;
 
 
 
 
 
 